import { trackPageView } from '../analytics.js';

export type InfoPageType = 'subscription' | 'terms' | 'privacy';

export interface BreadcrumbItem {
  name: string;
  path: string;
}

export interface SeoMeta {
  title: string;
  description: string;
  canonicalPath: string;
  breadcrumbs?: BreadcrumbItem[];
}

export function applyPageSeo(meta: SeoMeta) {
  if (typeof document === 'undefined') return;
  document.title = meta.title;
  const canonicalUrl = `https://arvangurav.com${meta.canonicalPath}`;
  const setMeta = (selector: string, attr: string, val: string) => {
    const el = document.querySelector(selector);
    if (el) el.setAttribute(attr, val);
  };
  setMeta('meta[name="description"]', 'content', meta.description);
  setMeta('link[rel="canonical"]', 'href', canonicalUrl);
  setMeta('meta[property="og:title"]', 'content', meta.title);
  setMeta('meta[property="og:description"]', 'content', meta.description);
  setMeta('meta[property="og:url"]', 'content', canonicalUrl);
  setMeta('meta[name="twitter:title"]', 'content', meta.title);
  setMeta('meta[name="twitter:description"]', 'content', meta.description);
  trackPageView(meta.canonicalPath, meta.title);

  // Update or inject BreadcrumbList Schema.org structured data
  if (meta.breadcrumbs && meta.breadcrumbs.length > 0) {
    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      '@id': `${canonicalUrl}#breadcrumbs`,
      itemListElement: meta.breadcrumbs.map((b, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: b.name,
        item: `https://arvangurav.com${b.path}`,
      })),
    };
    let scriptEl = document.getElementById('schema-breadcrumbs') as HTMLScriptElement | null;
    if (!scriptEl) {
      scriptEl = document.createElement('script');
      scriptEl.id = 'schema-breadcrumbs';
      scriptEl.type = 'application/ld+json';
      document.head.appendChild(scriptEl);
    }
    scriptEl.textContent = JSON.stringify(breadcrumbSchema);
  } else {
    const scriptEl = document.getElementById('schema-breadcrumbs');
    if (scriptEl) scriptEl.remove();
  }
}
